import React from "react";
export const Navigation = (props) => {

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a  href="#page-top">
            <img className="banner-img" src="img/logo.png" alt="logo" /> 
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >

<ul className="nav navbar-nav navbar-right">
<li>
          <a href="#features" className="page-scroll">
            AI赋能
          </a>
        </li>
        <li>
          <a href="#about" className="page-scroll">
            关于众店
          </a>
        </li>
        <li>
          <a href="#services" className="page-scroll">
            众店服务
          </a>
        </li>
        <li>
          <a href="#portfolio" className="page-scroll">
            运营模式
          </a>
        </li>
        {/* <li>
          <a href="#testimonials" className="page-scroll">
            Testimonials
          </a>
        </li> */}
        <li>
          <a href="#team" className="page-scroll">
            战略合作团队
          </a>
        </li>
        <li>
          <a href="#contact" className="page-scroll">
            联系众店
          </a>
        </li>
      </ul>
      </div>
    </div>
  </nav>

  );
};
